import React, { Fragment, useState, useEffect } from 'react'
import DataTable from 'react-data-table-component'
import { Button, Col, OverlayTrigger, Row, Tooltip, Modal, Spinner, Alert } from 'react-bootstrap';

import SearchComponent from '../../_Components/SearchComponent';
import RenderProfilePicture from '../../../../../../_helpers/profile-picture';
import { usersService } from '../../../../../../_services/users.service';
import httpStatus from 'http-status';
import { Link } from 'react-router-dom';

export default function ListTeams({ user, reload, licensedTeams, handleShowAddToTeam }) {
  const [data, setData] = useState({})
  const [showModal, setShowModal] = useState(false)
  const [licensedTeam, setLicensedTeam] = useState()
  const [removing, setRemoving] = useState(false)
  const [error, setError] = useState()

  useEffect(() => {
    setData(licensedTeams)
  }, [licensedTeams])

  const columns = [
    {
      name: 'LICENSED USER',
      sort: false,
      cell: row => {
        let fullName = `${row.firstName} ${row.lastName}`

        if (row.credentials) {
          fullName = `${fullName}, ${row.credentials}`
        }
        
        return <div className='row w-100'>
          <div className="col-auto">
            <RenderProfilePicture height={30} width={30} image={row.profileUrl} circle cached={false} className='m-auto' />
          </div>
          <div className="col-auto">
            <div className="row">
              <div className="col">
                <div>{fullName}</div>
              </div>
            </div>
            <div className="row">
              <div className="col">
                <span className='text-muted'>{row.specialtyTitle}</span>
              </div>
            </div>
          </div>
        </div>
      }
    },
    {
      name: '',
      sort: false,
      cell: (row) => {
        return <div className='w-100 d-flex justify-content-end'>
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>View team</Tooltip>}
          >
            <Link
              as={Button}
              className="btn btn-outline-primary btn-sm mr-2"
              to={`/account/users/${row.userId}`}>
              <i className="fa fa-eye"></i>
            </Link>
          </OverlayTrigger>

          <OverlayTrigger
            placement="top"
            overlay={<Tooltip>Remove From team</Tooltip>}
          >
            <button 
              title="Remove"
              onClick={() => {
                setLicensedTeam(row)
                setShowModal(true)
              }}
              className="btn btn-outline-danger btn-sm">
              <i className="far fa-trash-alt"></i>
            </button>
          </OverlayTrigger>

        </div>
      }
    },
  ];

  const filterByName = (search) => {
    if (!search) {
      setData(licensedTeams);
    } else {
      setData(licensedTeams.filter(row => {
        return row.firstName.toLowerCase().indexOf(search.toLowerCase()) !== -1 || row.lastName.toLowerCase().indexOf(search.toLowerCase()) !== -1
      }))
    }
  }

  const removeTeam = () => {
    setRemoving(true)

    usersService.removeFromTeam(user.userId, licensedTeam.licensedId)
      .then(() => {
        reload()
        setShowModal(false)
      })
      .catch(error => {
        if (error.response && error.response.status === httpStatus.UNPROCESSABLE_ENTITY) {
          setError(error.response.data.message);
        } else {
         setError('We could not remove from the licensed team. Please try again.');
        }
      })
      .then(() => setRemoving(false));
  }

  const staffName = `${user.firstName} ${user.lastName}`
  const licensedTeamName = licensedTeam ? `${licensedTeam.firstName} ${licensedTeam.lastName}` : ''

  return (
    <Fragment>
      <Modal show={showModal} onHide={() => setShowModal(false) } size='lg'>
        <Modal.Header closeButton>
          <Modal.Title>Remove From Team</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          { error && <Alert variant='danger'>{ error }</Alert> }
          <Row>
            <Col>
              <p>{`By removing from the team, ${staffName} will not receive any notification for ${licensedTeamName}.`}</p>
              <p>Are you sure you want to remove from the team?</p>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Row className='w-100 justify-content-end'>
            <Col xs='4'>
              <Button disabled={removing} onClick={removeTeam} block variant='success'>
                { removing ? <Spinner size='sm' animation='border' /> : 'Yes, remove'}
              </Button>
            </Col>
            <Col xs='3'>
              <Button disabled={removing} onClick={() => setShowModal(false) } block variant='secondary'>No, cancel</Button>
            </Col>
          </Row>
        </Modal.Footer>
      </Modal>

      <div className='lead pb-3'>Licensed Team</div>
      <Row>
         <Col>
          <div className="axs-shadow axs-rounded p-1 mb-3" style={{background: 'white'}}>
            <DataTable
              noHeader
              columns={columns}
              data={data}
              subHeader
              subHeaderComponent={<SearchComponent placeholder='Search Licensed User' handleSearch={search => filterByName(search) } />}
              pagination={false}
              customStyles={{ 
                cells: { style: { fontSize: '14px', padding: '1.5em' }, }, 
                headCells: { style: { fontWeight: 400, color: 'RGB(161, 165, 183)', padding: '1.5em'}, }, 
                subHeader: { style: { justifyContent: 'space-between', padding: '10px 10px 0 10px' } }
              }}
            />
          </div>
         </Col>
         <Col xs='3'>
            <Button block variant='success' onClick={handleShowAddToTeam}>Add To Team</Button>
         </Col>
      </Row>
    </Fragment>
  )
}
